
import React, {useContext, useEffect, useRef, useState} from "react";
import {App, Form, Input, Table, Tag} from "antd";
import copyToClipboard from "../../utils/clipboard";
import {PlusCircleFilled} from "@ant-design/icons";

const EditableContext = React.createContext(null);



const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        //setEditing(true);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {

            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingInlineEnd: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};

function HeadersTabTable(props) {

    const { message } = App.useApp();

    useEffect(() => {

    }, []);

    const handleSave = (row) => {
        const newData = [...props.headers];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        props.onHeadersChanged(newData)
    };

    function onAddNewHeader () {
        if (props.onAddNewHeader) {
            props.onAddNewHeader()
        }
    }

    const defaultColumns = [
        {
            title: 'Key',
            dataIndex: 'key',
            editable: props.canEdit,
        },
        {
            title: <div className="column-value">
                <span>Value</span>
                {props.canEdit ? <PlusCircleFilled className="icon" onClick={onAddNewHeader}></PlusCircleFilled> : false}
            </div>,
            editable: props.canEdit,
            dataIndex: 'value'
        },
    ];

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),

        };
    });

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    return (
        <Table className="headers-table" onRow={(record, rowIndex) => {
            return {
                onClick: (event) => {
                   //console.log('ON_HEADER_CLICK',record,rowIndex)
                    if (props.canCopyToclipBoard) {
                        copyToClipboard(record.value).then(r => {
                            message.open({type: 'success', content: 'Copied to clipboard'});
                        })
                    }
                }
            }
        }}
               onHeaderCell={(columns) => {
                   return {
                       onClick: (e) => {
                           console.log('CLICK',columns,e)
                       },
                   };
               }}
               components={components} rowClassName={() => 'editable-row'} pagination={{hideOnSinglePage:true}} dataSource={props.headers} columns={columns}/>
    );
}

export default HeadersTabTable;
